import { GetStateByStateKeyResponse } from '@iwoca/lapi-client/edge';

type People = NonNullable<
  NonNullable<GetStateByStateKeyResponse['data']['application']>['people']
>;

export function getApplicant(
  people: People | undefined | null,
): People[number] | null {
  return (
    people?.find((person) => person.roles?.includes('applicant')) ??
    people?.[0] ??
    null
  );
}
